import React, { useState } from 'react';
import AlalayScreen from './components/AlalayScreen';
import ArenaScreen from './components/ArenaScreen';
import BarangayScreen from './components/BarangayScreen';

const TABS = [
  { id: 'alalay', label: 'Alalay', emoji: '⚡' },
  { id: 'arena', label: 'Arena', emoji: '🏟️' },
  { id: 'barangay', label: 'Barangay', emoji: '🏘️' }
];

export default function App() {
  const [tab, setTab] = useState('alalay');
  const [botConfig, setBotConfig] = useState({
    name: 'Alalay Ko',
    style: 'Torpe but witty — maingat magsalita pero matalim mag-isip.',
    instrux: ''
  });
  const [stats, setStats] = useState({ elo: 0, wins: 0, losses: 0, battles: 0 });

  function handleBattleEnd({ won, draw, eloChange }) {
    setStats(prev => ({
      elo: Math.max(0, prev.elo + eloChange),
      wins: prev.wins + (won ? 1 : 0),
      losses: prev.losses + (!won && !draw ? 1 : 0),
      battles: prev.battles + 1
    }));
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{
        padding: '1.25rem 1rem 0.75rem',
        textAlign: 'center',
        borderBottom: '1px solid var(--border)',
        background: 'rgba(13,1,32,0.8)',
        backdropFilter: 'blur(12px)',
        position: 'sticky', top: 0, zIndex: 100
      }}>
        <div style={{
          fontFamily: 'var(--font-display)',
          fontSize: 26, fontWeight: 800,
          letterSpacing: '-0.5px'
        }}>
          <span style={{ color: 'var(--purple)' }}>GALING</span>
          <span style={{ color: 'var(--coral)' }}>BOT</span>
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1, letterSpacing: '0.5px' }}>
          I-train mo, i-reign mo! 🇵🇭
        </div>
      </header>

      <div style={{
        display: 'flex',
        borderBottom: '1px solid var(--border)',
        background: 'rgba(13,1,32,0.8)',
        backdropFilter: 'blur(12px)',
        position: 'sticky', top: 72, zIndex: 99
      }}>
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              flex: 1, padding: '12px 6px',
              background: 'transparent',
              border: 'none',
              borderBottom: `2px solid ${tab === t.id ? 'var(--purple)' : 'transparent'}`,
              color: tab === t.id ? 'var(--text)' : 'var(--text-muted)',
              fontFamily: 'var(--font-display)',
              fontSize: 12, fontWeight: 700,
              letterSpacing: '0.5px',
              cursor: 'pointer',
              transition: 'all 0.15s',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 2
            }}
          >
            <span style={{ fontSize: 18 }}>{t.emoji}</span>
            {t.label}
          </button>
        ))}
      </div>

      <main style={{ flex: 1, maxWidth: 480, margin: '0 auto', width: '100%', padding: '1rem' }}>
        {tab === 'alalay' && (
          <AlalayScreen botConfig={botConfig} setBotConfig={setBotConfig} stats={stats} />
        )}
        {tab === 'arena' && (
          <ArenaScreen botConfig={botConfig} stats={stats} onBattleEnd={handleBattleEnd} />
        )}
        {tab === 'barangay' && (
          <BarangayScreen stats={stats} />
        )}
      </main>

      <footer style={{
        textAlign: 'center', padding: '1rem',
        fontSize: 11, color: 'var(--text-muted)',
        borderTop: '1px solid var(--border)'
      }}>
        GalingBot · Gawa ng mga Pilipino, para sa mga Pilipino 🇵🇭
      </footer>
    </div>
  );
}
